import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PartSales = {
	name: NAME,
	apiProvider,
	router,
};
